<div class="container">
  <mic-breadcrumb id="casing-credit-copy-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casingCredit"
      label="{{ translationService.translate('casingCreditText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('copyCasingCreditText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title casing-credit-copy-heading" id="casing-credit-copy-heading">
    {{ translationService.translate('copyCasingCreditText') }}
  </h2>

  <mat-card class="casing-credit-copy-form-card">
    <form [formGroup]="codeForm" class="casing-credit-copy-form">
      <div class="code-form-layout">
        <div class="code-fields">
          <div class="code-field-container">
            <mat-form-field class="w-full" id="codeField" appearance="fill">
              <mat-label>{{ this.translationService.translate('codeText') }}</mat-label>
              <input
                id="code-input"
                matInput
                formControlName="code"
                required
                maxlength="20"
                [attr.aria-label]="translationService.translate('codeText')"
                (blur)="checkIfCasingCreditCodeExists()"
              />
              @if (codeForm.get('code').hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              } @if (codeForm.get('code').hasError('exists')) {
              <mat-error>
                {{ translationService.translate('codeExistsText') }}
              </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="description-field-container">
            <mat-form-field class="w-full" id="descriptionField" appearance="fill">
              <mat-label>{{ translationService.translate('descriptionText') }}</mat-label>
              <input
                id="description-input"
                matInput
                formControlName="description"
                required
                maxlength="35"
                [attr.aria-label]="translationService.translate('descriptionText')"
              />
              @if (codeForm.get('description').hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="action-bar">
          <button id="cancel" mat-flat-button class="btn-cancel casing-credit-copy-action-button" (click)="cancel()">
            <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelLinkText') }}
          </button>
          <button
            id="save"
            type="button"
            mat-flat-button
            color="primary"
            class="btn-primary casing-credit-copy-action-button"
            (click)="save()"
          >
            <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
          </button>
        </div>
      </div>
    </form>
  </mat-card>

  <!-- Loading Overlay -->
  @if (isLoading) {
  <div class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  }

  <mat-card class="casing-credit-copy-filter-card">
    <form [formGroup]="filterForm" class="casing-credit-copy-filter-form">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="size"
          label="{{ translationService.translate('sizeText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('sizeText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('sizeText') }}"
          [formGroup]="filterForm"
          formControlName="size"
          [data]="sizeList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="description"
          label="{{ translationService.translate('descriptionText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          [formGroup]="filterForm"
          formControlName="description"
          [data]="descriptionList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="baseCredit"
          label="{{ translationService.translate('baseCreditText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('baseCreditText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('baseCreditText') }}"
          [formGroup]="filterForm"
          formControlName="baseCredit"
          [data]="baseCreditList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="repairGrid"
          label="{{ translationService.translate('repairGridText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('repairGridText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('repairGridText') }}"
          [formGroup]="filterForm"
          formControlName="repairGrid"
          [data]="repairGridList"
        >
        </app-dropdown-search-single-select>
      </div>
      <div class="button-container">
        <button
          id="clear-filters"
          type="button"
          mat-flat-button
          color="accent"
          class="btn-clear clear-filters-button"
          (click)="clearFilters()"
        >
          <mat-icon>refresh</mat-icon> {{ translationService.translate('clearFiltersText') }}
        </button>
      </div>
    </form>
  </mat-card>

  <div id="casing-credit-copy-table" class="cam-table table-container btn-table">
    <div class="table-wrapper">
      <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button><mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}</button>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'repairGridDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [widthConfig]="{ width: '100%', maxWidth: '300px' }"
            [virtualScroll]="true"
            [data]="repairGridList"
            [formControl]="getControl(item, 'repairGrid')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'baseCredit'">
          <input
            id="BaseCreditInput"
            matInput
            type="text"
            min="0"
            step="0.01"
            pattern="^\\d+(\\.\\d{1,2})?$"
            maxlength="6"
            [attr.aria-label]="translationService.translate('baseCreditText')"
            [formControl]="getControl(item, 'baseCredit')"
          />
        </ng-container>
      </mic-table>
    </div>
  </div>

  <!-- Unsaved Changes Modal -->
  <ng-template #unsavedConfirmation>{{ translationService.translate('unSaveChangesText') }}</ng-template>
  <mic-modal class="modalC" #unsavedChangesModal></mic-modal>
</div>
